import api from '@/services/api'

const getAvaliablesQuestionnairesToEvaluate = async userId => {
    try {
        const resp = await api.get(
            `/questionnaires/${userId}/spontaneous-questionnaires-avaliable-to-users`
        )
        return resp.data.data
    } catch (error) {
        console.error(error)
    }
}

export default getAvaliablesQuestionnairesToEvaluate
